var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
export var ImgWithFallback = function ImgWithFallback(_a) {
  var src = _a.src,
      fallback = _a.fallback,
      _a$customStyle = _a.customStyle,
      customStyle = _a$customStyle === void 0 ? {} : _a$customStyle,
      _a$type = _a.type,
      type = _a$type === void 0 ? 'image/webp' : _a$type,
      delegated = __rest(_a, ["src", "fallback", "customStyle", "type"]);

  return React.createElement("picture", {
    style: customStyle
  }, React.createElement("source", {
    srcSet: src,
    type: type
  }), React.createElement("img", Object.assign({
    src: fallback
  }, delegated)));
};